<template>
  <div class="ala-container">
    <el-header class="top-bar flex">
      <div class="top-bar-left flex">
        <div class="logo-box">
          <img src="../../assets/image/logo.png" alt="" />
        </div>
      </div>
      <div class="top-bar-right flex">
        <el-button size="small" plain style="margin-right: 15px;" @click="changeLanguage">{{ $t('langBtn') }}</el-button>
        <el-dropdown @command="handleCommand">
          <div class="el-dropdown-link">
            <div class="avatar-box flex">
              <span class="avatar-name">{{user.name}}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('exit') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
  </div>
</template>

<script>

import {apiLogout,getUserInfo} from  "../../plugins/api"
export default {
  data() {
    return {
      user:{},
      langBtn:'',
    };
  },
  async mounted() {
    await this.userInfo()
    // window.localStorage.setItem('app-language','en')
    console.log(this.$i18n.locale)
    if(this.$i18n.locale==='en'){
      this.langBtn = '中文'
    }else{
      this.langBtn = 'EN'
    }
    // this.$i18n.locale = 'en'
  },
  methods: {
    async handleCommand(e){
      if(e === 'logout'){
          let res = await apiLogout()
          if(res.code === 200){
              window.localStorage.removeItem('app_review_token');
              this.$router.push('login')
          }
      }
    },
    changeLanguage(){
      this.$i18n.locale = this.$i18n.locale==='en'?'zh':'en'
    },
    async userInfo(){
      let res = await getUserInfo();
      if(res.code === 200){
        this.user = res.data.user
      }
    },
    
  },
  components: {},
};
</script>
